import React from 'react';
import { getCountyDetails } from '../utils/countyUtils';
import ContactInfo from './ContactInfo';
import styles from '../App.module.less';

const CMEResults = ({ selectedCounty, cmeData, onBackToSearch }) => {
  const countyDetails = getCountyDetails(selectedCounty);
  const cmeForCounty = cmeData.filter((row) => row.Counties.includes(selectedCounty));

  return (
    <>
      <div className={`${styles.header} ${styles.cmeF35}`}>
        Your Care Management Entity
      </div>

      <div className={styles.results}>
        {cmeForCounty.map((row, index) => (
          <div key={index}>
            <div className={`${styles.cme} ${styles.cmeF20}`}>
              <button className={`${styles.back} ${styles.cmeF16}`} onClick={onBackToSearch}>
                Back to Search
              </button>

              <div className={`${styles.cmeF30}`}>{selectedCounty} County</div>

              <img src={`/logos/${row.Logo}`} alt={`${row.Name} Logo`} />
              <strong>{row.Name}</strong>
              <div className={styles.labeled}>
                <strong>Website:</strong>
                <div>
                  <a href={row.Website} target="_blank" rel="noreferrer">
                    {row.WebsiteLabel}
                  </a>
                </div>
              </div>
              <div className={styles.labeled}>
                <strong>Email:</strong>
                <div>
                  {row.Email && row.Email.split(',').map((email, index) => (
                    <>
                      <a className={styles.emailwrap} href={`mailto:${email.trim()}`}>{email.trim()}</a>{' '}
                    </>
                  ))}
                </div>
              </div>
              <div className={styles.labeled}>
                <strong>Phone:</strong>
                <div>
                  <a href={`tel:${row.Phone}`}>{row.Phone}</a>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {countyDetails?.[2] && (
        <div className={`${styles.disclaimer} ${styles.cmeF16}`}>
          <div className={`${styles.heading} ${styles.cmeF20}`}>
            Disclaimer
          </div>
          <div className={`${styles.subheading}`}>
            {selectedCounty} County serves the following zip codes:
          </div>
          {countyDetails[2]}
        </div>
      )}

      <ContactInfo />
    </>
  );
};

export default CMEResults;